import React, {Component} from "react";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import AgencyModuleManageAccountsInfo from "./AgencyModuleManageAccountsInfo";
import {FlexIndicatorsComponent} from "./flex_indicators/FlexIndicatorsComponent";

export class AgencyFlexIndicatorsConfigurationContent extends Component {
    render() {
        return (
            <section className="section-content agency-page agency-flex-indicators-page">
                <AgencyHeader/>
                <AgencyTabs activeTab="-seventh"/>
                <div className="section-body -widest h-items" style={{paddingBottom:'0em'}}>
                    <FlexIndicatorsComponent />
                </div>
                <div className="section-body h-items">
                    <AgencyModuleManageAccountsInfo/>
                </div>
            </section>
        )
    }
}
